const privacyPolicyEN = {
	title: "Privacy Policy",
	lastUpdated: "Effective Date",

	intro: {
		p1: `{{COMPANY_NAME}} (“we,” “our,” or “us”) provides an online platform to help clients book barbershop and beauty appointments and to help barbers and business owners manage schedules and communications (“Services”). This Privacy Policy explains what information we collect, how we use it, and your rights and choices.`,
		p2: "By using our website, app, or Services, you agree to this Privacy Policy. If you do not agree, please do not use the Services.",
	},

	infoCollect: {
		heading: "1. Information We Collect",
		provided: "a) Information You Provide",
		providedList: [
			"Account details: name, email, phone number, password (hashed), profile information, preferred language.",
			"Booking & shop data: selected services, date/time, barber or shop, notes, booking status and history.",
			"Communications: messages you send to us, and reminders or notifications we send.",
		],
		automatic: "b) Information Collected Automatically",
		automaticList: [
			"Device & usage data: IP address, browser type, pages visited, timestamps, and basic analytics.",
			"Cookies and similar technologies to remember preferences and improve the Services.",
		],
		thirdParty: "c) Information from Third Parties",
		thirdPartyList: [
			"Social media accounts or third-party integrations you connect.",
			"Payment processors (for business fees only).",
		],
	},

	howWeUse: {
		heading: "2. How We Use Your Information",
		list: [
			"Provide, operate, and improve the Services.",
			"Process payments and manage business accounts.",
			"Send transactional messages.",
			"Personalize your experience.",
			"Monitor performance and prevent abuse.",
			"Comply with legal obligations.",
		],
	},

	sharing: {
		heading: "3. How We Share Information",
		list: [
			"With Barbers/Shops You Book.",
			"With Service Providers.",
			"For legal, safety, or compliance reasons.",
			"During business transfers.",
		],
		noSell: "We do not sell personal data to third parties.",
	},

	cookies: {
		heading: "4. Cookies & Analytics",
		text: "Essential cookies operate the Services; optional analytics cookies help us understand usage.",
	},

	security: {
		heading: "5. Data Security",
		text: "We implement reasonable technical and organizational measures to protect your data.",
	},

	retention: {
		heading: "6. Data Retention",
		text: "We keep your personal information only as long as necessary to provide the Services and comply with the law.",
	},

	international: {
		heading: "7. International Transfers",
		text: "Your information may be processed or stored in countries other than your own.",
	},

	minors: {
		heading: "8. Parental Consent / Minors",
		p1: "Users under the age of majority may only use the Services with parental or legal guardian consent.",
		p2: "Our Services are not directed to children under 13.",
	},

	userContent: {
		heading: "9. User-Generated Content",
		p1: "Reviews and content you submit may be displayed on the platform.",
		p2: "By submitting content, you grant us a license to operate the Services.",
	},

	platform: {
		heading: "10. Platform Liability Reminder",
		p1: "Sin Fila is a platform only.",
		p2: "Disputes are between the user and the business.",
	},

	rights: {
		heading: "11. Your Rights & Choices",
		list: [
			"Access & Update your information.",
			"Request deletion.",
			"Opt-out of marketing emails.",
			"Manage cookies.",
		],
		contact: "To exercise rights, contact {{CONTACT_EMAIL}}.",
	},

	changes: {
		heading: "12. Changes to This Privacy Policy",
		text: "We may update this Policy from time to time.",
	},

	contact: {
		heading: "13. Contact Us",
		text: "For questions, contact {{CONTACT_EMAIL}}.",
	},
};

export default privacyPolicyEN;
